exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tabbar{position:absolute;bottom:0;left:0;width:100%;height:44px;z-index:10;background-color:#fff;display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0;padding:0;box-shadow:0 0 10px rgba(0,0,0,.15);opacity:0;transition:opacity .2s;-webkit-transition:opacity .2s}.tabbar.visible{opacity:1}.tabbar.fixed{position:fixed}.tabbar .tabbar-item{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-moz-flex:1;-ms-flex:1;flex:1;-webkit-box-direction:normal;-webkit-box-orient:vertical;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.tabbar .tabbar-item .icon-wrapper{-webkit-box-flex:none;-moz-flex:none;-ms-flex:none;flex:none;height:32px;text-align:center;font-size:28px;line-height:32px}.tabbar .tabbar-item .text-wrapper{-webkit-box-flex:1;-moz-flex:1;-ms-flex:1;flex:1;text-align:center;font-size:20px;line-height:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/services/tabbar/Tabbar.vue
// module id = 178
// module chunks = 0